const language = {
    'pt':
    {
        add_new: 'Adicionar novo',
        cancel: 'Cancelar', back: 'Voltar',
        close: 'Fechar',
        config: 'Configuração',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_new: 'Novo conteúdo',
        content_list: 'Lista de conteúdos',
        dark_mode: 'Dark mode',
        dates: 'Datas',
        date_creation: 'Criação',
        date_publication: 'Publicação',
        date_last_update: 'Última actualização',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        morada: 'Morada',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        phone: 'Telefone',
        phone_placeholder: 'Introduza o telefone',
        email: 'Email',
        email_placeholder: 'Introduza o email',
        entity: 'Clube',
        entity_edit: 'Editar Clube',
        entity_new: 'Novo Clube',
        entity_list: 'Lista de Clubes',
        filter_placeholder: 'Procurar',
        id: 'ID',
        logo: 'Logo',
        logo_choose: 'Escolher logo',
        noLogo: 'Sem logo',
        logo_remove: 'Remover logo',
        logo_error: 'Problema ao carregar o logo!',
        logo_success: 'Logo carregado com sucesso!',
        language: 'Lingua',
        login_data: 'Dados de login',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        data_constituicao: 'Data de constituição',
        data_filiacao: 'Data de Filiação na Federação',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        password: 'Password',
        password_confirmation: 'Confirmação da Password',
        password_placeholder: 'Introduza a password',
        password_title: 'Password!',
        password_text: 'As Passwords não correspondem.',
        password_confirm: 'Continue',
        password_cancel: 'No',
        password_error: 'Problem inserting element!',
        password_success: 'Successful inserted element!',
        personal_data: 'Dados pessoais',
        principal: 'Principal',
        profile: 'Perfil',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_type: 'Tipo',
        table_count: 'Count',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'Sem Resultados',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introzuda o título',
        save: 'Salvar',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        warning_title: 'Aviso!',
        warning_text: 'O username já existe no sistema.',
        warning_confirm: 'Continuar',
        warning_cancel: 'Não',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',

        // Modalidades      
	    modalidades: 'Modalidades',
        modalidades_placeholder: 'Selecione as modalidades',

        // Representantes
        presidente: 'Presidente',

        // Atletas
        numero_federacao: 'Nº Federação',
        epoca: 'Época',

        // Contrato Programa
        contrato_programa: 'Contrato Programa',

        // Upload de ficheiros
        upload_de_ficheiros: 'Upload de ficheiros',
        ficheitos_da_associacao: 'Ficheiros da Associação',
        estatutos: 'Estatutos',
        constituicao_associacao: 'Constituição de Associação',
        acta_tomada_posse: 'Acta de tomada de posse',
        declaracoes_ss: 'Declarações SS',
        declaracoes_at: 'Declarações AT',
        plano_atividades: 'Plado de Atividades',
        relatorio_intermedio: 'Relatório Intermédio',
        relatorio_final: 'Relatório Final',
        noFile: 'Sem ficheiro',
        doc_choose: 'Escolher ficheiro',
        upload_file_error: 'Formato do ficheiro incorrecto: ',

        // Morada
        local: 'Local',
        local_placeholder: 'Introduza o local',
        postal_code: 'Código Postal',
        postal_code_placeholder: '0000-000',
        village: 'Freguesia',
        village_placeholder: 'Selecione a freguesia',
        city: 'Concelho',
        city_placeholder: 'Selecione o concelho',
        district: 'Distrito',
        district_placeholder: 'Selecione o distrito',
        country: 'País',
        country_placeholder: 'Selecione o país',

    },
    'en':
    {
        add_new: 'Add new',
        cancel: 'Cancel', back: 'Voltar',
        close: 'Close',
        config: 'Clonfiguration',
        content: 'Content',
        content_edit: 'Edit content',
        content_new: 'New content',
        content_list: 'Content list',
        dates: 'Dates',
        date_creation: 'Creation',
        date_publication: 'Publication',
        date_last_update: 'Last update',
        delete: 'Delete',
        delete_title: 'Delete Regist',
        delete_text: 'Are you sure you want to continue?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Problem deleting the element!',
        delete_success: 'Element deleted successfully!',
        description: 'Description',
        description_placeholder: 'Insert a description',
        edit: 'Edit',
        edit_title: 'Edit Regist',
        edit_text: 'Are you sure you want to continue?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Problem updating element!',
        edit_success: 'Successful updated element!',
        entity: 'Webuser',
        entity_edit: 'Edit user',
        entity_new: 'New user',
        entity_list: 'User List',
        filter_placeholder: 'Search',
        id: 'ID',
        language: 'Language',
        login_data: 'Login data',
        name: 'Name',
        name_placeholder: 'Insert the name',
        image: 'Image',
        image_choose: 'Choose imagem',
        insert_title: 'New Regist',
        insert_text: 'Are you sure you want to continue?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Problem updating element!',
        insert_success: 'Successful updated element!',
        password: 'Password',
        password_confirmation: 'Password confirmation',
        password_placeholder: 'Insert the password',
        password_title: 'Password!',
        password_text: 'The password do not match.',
        password_confirm: 'Continue',
        password_cancel: 'No',
        password_error: 'Problem inserting element!',
        password_success: 'Successful inserted element!',
        personal_data: 'Personal data',
        principal: 'Principal',
        profile: 'Profile',
        remove: 'Remove',
        table_rows_per_page: 'Regist by page:',
        table_separator: 'of',
        table_all: 'All',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_parent: 'Parent',
        table_date: 'Date',
        table_type: 'Type',
        table_count: 'Count',
        table_state: 'State',
        table_actions: 'Actions',
        table_empty: 'no results',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Insert title',
        save: 'Save',
        username: 'Username',
        username_placeholder: 'Insert the username',
        warning_title: 'Warning!',
        warning_text: 'The username is already in the system.',
        warning_confirm: 'Continue',
        warning_cancel: 'No',
        warning_error: 'Problem inserting element!',
        warning_success: 'Successful inserted element!',

        // Modalidades
        modalidades: 'Sports/Disciplines',
        modalidades_placeholder: 'Select the disciplines',

        // Representantes
        presidente: 'President',

        // Atletas
        numero_federacao: 'Federation No.',
        epoca: 'Season',

        // Contrato Programa
        contrato_programa: 'Program Contract',

        // Upload de ficheiros
        upload_de_ficheiros: 'File uploads',
        estatutos: 'Bylaws',
        acta_tomada_posse: 'Inauguration Minutes',
        declaracoes_ss: 'Social Security Statements',
        declaracoes_at: 'Tax Authority Statements',
        noFile: 'No file',
        doc_choose: 'Choose file',
        upload_file_error: 'Incorrect file format: ',

        // Address
        local: 'Locality',
        local_placeholder: 'Enter the locality',
        postal_code: 'Postal Code',
        postal_code_placeholder: '0000-000',
        village: 'Parish',
        village_placeholder: 'Select the parish',
        city: 'City/Council',
        city_placeholder: 'Select the city/council',
        district: 'District',
        district_placeholder: 'Select the district',
        country: 'Country',
        country_placeholder: 'Select the country',
    }
}

module.exports = {
    language
};